module.exports = __webpack_public_path__ + "img/ceshi.d4692dac.jpg";